import { CommonModule } from '@angular/common';
import { Component, computed, input, output, signal } from '@angular/core';

import {
  type ChatSuggestion,
  type ChatWelcomeConfig,
} from '../../interfaces/chat.interfaces';

@Component({
  selector: 'app-chat-welcome-screen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './welcome-screen.component.html',
  styleUrl: './welcome-screen.component.scss',
})
export class WelcomeScreenComponent {
  /**
   * Welcome screen configuration
   */
  public readonly config = input<ChatWelcomeConfig>();

  /**
   * Emitted when a suggestion is clicked
   */
  public readonly suggestionSelected = output<string>();

  /**
   * Tracks if the icon image failed to load
   */
  protected readonly _iconLoadError = signal(false);

  /**
   * Computed welcome message from config
   */
  protected readonly welcomeMessage = computed(() => {
    return this.config()?.message ?? '';
  });

  /**
   * Computed suggestions from config
   */
  protected readonly suggestions = computed<readonly ChatSuggestion[]>(() => {
    return this.config()?.suggestions ?? [];
  });

  /**
   * Handle icon load error - fallback to emoji
   */
  protected _onIconError(): void {
    this._iconLoadError.set(true);
  }

  /**
   * Handle suggestion click
   */
  protected onSuggestionClick(suggestion: ChatSuggestion): void {
    this.suggestionSelected.emit(suggestion.text);
  }
}
